import { render, staticRenderFns } from "./settlement-grade-card.vue?vue&type=template&id=3ef388d4&"
import script from "./settlement-grade-card.vue?vue&type=script&lang=js&"
export * from "./settlement-grade-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports